export default __webpack_public_path__ + "static/media/nft17.ff249358.png";